// @flow
import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';

import { optionalEquipmentTypes } from '../../../lib/enum';

const { Option } = Select;

export default (props: SelectProps) => (
  <Select {...props}>
    {Object.keys(optionalEquipmentTypes).map(key => (
      <Option value={key} key={key}>
        {optionalEquipmentTypes[key]}
      </Option>
    ))}
  </Select>
);
